import { Div, EditableLabel, Text } from "@tblabs/truffle";
import { TimeUtils } from "../../Utils/TimeUtils";
import { ChatEntry } from "../Models/ChatEntry";
import { ChatEntryStatus } from "../Models/ChatEntryStatus";


export class MessageBox extends Div
{
	constructor(type: "sent" | "received", entry: ChatEntry)
	{
		super("message " + type);
		this.Style("position: relative;");

		this.Append(
			new Div("message-user").Text(entry.Author.value),
			new Div("message-content").Text(entry.Message.value),
			// new EditableLabel(entry.Message).Class("message-content"), //.OnChange(msg => entry.Message.value = msg),
			new Div("message-time").Text(TimeUtils.FormattedDateTime(entry.Time.value)).Append(
				type == "sent" && new Text(entry.Status).Class("message-status")
					.VisibleWhen(entry.Status, s => s != ChatEntryStatus.Unsent)
			),
			// new ContextMenu({ "Usuń": () => { }, "Edytuj": () => { } }).PositionAbsolute().Right(-36).Top(24)
		);
	}
}
